import {gql} from "@apollo/client";
import {PricingSchemeApplyType} from "../types/PricingSchemeApplyType";

export const FIELDS = `
    id
    pricingSchemeId
    pricingSchemeName
    clientId
    clientName
    bindDimension
    bindValue
    bindValueDesc
    effectiveTime
    expirationTime
    bindTime
    unbindTime
    operatorId
    operatorName
    effectStatus
    bindStatus
    timezone
`;

export const GET_PRICING_SCHEME_APPLY_LISTING = gql`
    query PricingSchemeApplyQuery($filters: PricingSchemeApplyFilterTypeInput,
                       $pageRequest: PageRequestTypeInput) {
        getPricingSchemeApplyPageable(filters: $filters, pageRequest: $pageRequest) {
            content{
                ${FIELDS}
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface PricingSchemeApplyListResponse {
    getPricingSchemeApplyPageable: PricingSchemeApplyResponseType;
}

export interface PricingSchemeApplyResponseType {
    content: PricingSchemeApplyType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

